<template>
  <GenerateForm />
  <MailResult />
</template>

<script>
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'

import GenerateForm from './components/GenerateForm.vue'
import MailResult from './components/MailResult.vue'

export default {
  name: 'Generator',
  components: { GenerateForm, MailResult },
  setup() {
    const store = useStore()

    onBeforeMount(async () => {
      await store.dispatch('getMailsGeneratedToday')
    })

    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
</style>
